import {ReactComponentLike} from "prop-types";
import React, {ReactElement, useCallback} from "react";
import {DeserializedElement, DeserializedElementRule, TagType} from "../Transformation";
import {Editor, Element as SlateElement, Node as SlateNode, Transforms} from "slate";
import {ReactEditor} from "slate-react";

export default ({
    type,
    render,
    toolbarButton,
    tagType = () => 'inline',
    isVoid = () => true
}: {
    type?: string,
    render?: ReactComponentLike,
    toolbarButton?: JSX.Element|ReactElement|ReactComponentLike|null|undefined,
    tagType?: TagType,
    isVoid?: (element: SlateNode) => boolean
} = {}): DeserializedElementRule<HTMLElement> => {
    return {
        tagType,
        isVoid,
        match: (element) => element.type === 'component' && element.props.type === type,
        deserialize(el, next) {
            if (el.tagName?.toLowerCase() === 'component') {
                if (el.getAttribute("type") === type) {
                    const getAttributes = (el: HTMLElement): { [key: string]: any } => {
                        return Array.from(el.attributes)
                            .map(a => [a.name, a.value])
                            .reduce((acc, attr) => {
                                // @ts-ignore
                                acc[attr[0]] = attr[1]
                                return acc
                            }, {})
                    }

                    let props = getAttributes(el);
                    if (props.presetdata) {
                        props.presetdata = JSON.parse(props.presetdata);
                    }
                    if (props.filter) {
                        props.filter = JSON.parse(props.filter);
                    }

                    return {
                        type: 'component',
                        props,
                        children: next(el.childNodes)
                    } as DeserializedElement;
                }
            }
        },
        serialize(node, next) {
            if (node.type === 'component') {
                if (node.props.type === type) {
                    let props: { [key: string]: any } = {...node.props};
                    if (props.presetdata) {
                        props.presetdata = JSON.stringify(props.presetdata);
                    }
                    if (props.filter) {
                        props.filter = JSON.stringify(props.filter);
                    }
                    // @ts-ignore
                    return <component {...props}>{next(node.children)}</component>;
                }
            }
        },
        isActive: (editor) => {
            // @ts-ignore
            const [component] = Editor.nodes(editor, {
                match: n =>
                    !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'component' && n.props.type === type,
            })
            return !!component
        },
        toolbarButton,
        render: ({editor, node}) => {
            const remove = useCallback((e) => {
                e && e.preventDefault();
                const path = ReactEditor.findPath(editor, node.element);
                Transforms.removeNodes(editor, {at: path});
            }, []);
            if (node.element?.type === 'component') {
                if (node.element.props.type === type) {
                    let props = {remove};
                    const Comp = render;
                    return <Comp {...node} {...props} editor={editor}/>;
                }
            }
        }
    }
}